'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export default function RouteChangeTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    // Evita correr en SSR
    if (typeof window === 'undefined') return

    const query = searchParams?.toString()
    const page_path = query ? `${pathname}?${query}` : pathname
    const page_location = window.location.href
    const page_title = document.title

    // A GTM le alcanza con un push al dataLayer
    // GA4 (si está configurado en GTM) puede escuchar este evento y disparar page_view.
    // @ts-ignore
    window.dataLayer = window.dataLayer || []
    // @ts-ignore
    window.dataLayer.push({
      event: 'pageview',
      page_path,
      page_location,
      page_title,
    })
  }, [pathname, searchParams])

  return null
}
